import { inject, Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, map , of, switchMap } from "rxjs";
import { storeStars, storeStarsFailure, storeStarsSuccess } from 'src/app/store/actions/stars/stars.actions'
import { StarResponse } from "src/app/models";
import { backendService } from "src/app/domains/shared";


@Injectable()

export class StarsEffects {
    
    /* 
    * Injections
    */
    private action$ :                                                         Actions = inject(Actions);
    private backendService:                                                   backendService = inject(backendService);

    //#region MYSTARS

    storeStars$ = createEffect(() => {
        return this.action$
        .pipe(
            ofType(storeStars),
            switchMap( () => {
                return this.backendService.testbackendService(  )
                .pipe(
                    map(( starsResponse: StarResponse ) =>{

                        
                        return storeStarsSuccess( { starsResponse } );
                    }),
                    catchError(error => {
                        return of( storeStarsFailure({ error : error }) )
                    })
                )
            })
        )
    }) 
}